export default __webpack_public_path__ + "static/centered-results-2-ac72dd2c7e5a7446cba8ca8bbd2d332a.png";